<template>
    <div>
      <el-row :gutter="15">
            <el-col :span="12">
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col :span="12">
                            <span class="title_class">裁判功能</span>
                        </el-col>
                    </el-row>
                    <el-button
                        type="primary"
                        plain
                        icon="el-icon-download"
                        @click="exportExamData"
                        >导出全部成绩信息</el-button
                    >
                    <el-button
                      type="success"
                      icon="el-icon-upload2"
                      @click="importScoreInfo"
                      plain
                      >导入全部成绩信息</el-button
                  >
                </el-card>
            </el-col>
            <el-col :span="12">
                <!-- 筛选 -->
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col>
                            <span class="title_class">选择考场</span>
                        </el-col>
                    </el-row>
                    <el-form
                        :model="queryForm"
                        class="filter_Form"
                        label-width="90px"
                        ref="queryFormRef"
                    >
                        <el-row :gutter="20">
                            <el-col :span="16">
                                <el-form-item label="考场名称" prop="id" style="margin-bottom: 0;">
                                    <el-select
                                        v-model="queryForm.id"
                                        @change="examRoomChange"
                                        filterable
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in examRooms"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="15"> </el-row>
        <!-- 列表 -->
        <el-card class="list_card" style="margin-top: 20px">
            <el-row class="title_row">
                <el-col :span="12">
                    <span class="title_class">
                        <div class="list_title">比赛信息</div>
                        <i
                            class="refresh"
                            :class="
                                loading ? 'el-icon-loading' : 'el-icon-refresh'
                            "
                            @click="get3DataList"
                        ></i>
                    </span>
                </el-col>
                <!-- <el-col :span="12">
          <div style="text-align: right">
            <el-button type="primary" @click="addExamineeClick"
              >添加考生</el-button
            >
          </div>
        </el-col> -->
            </el-row>
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="dataList"
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
                :row-class-name="tableRowClassName"
                border
            >
                <el-table-column label="#" type="index"></el-table-column>
                <el-table-column label="姓名" prop="userName" width="100px">
                    <template slot-scope="scope">
                        <span>{{ scope.row.userName }}</span>
                    </template></el-table-column
                >
                <el-table-column label="手机号" prop="phone">
                    <template slot-scope="scope">
                        <span>{{ scope.row.phone }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="年级"
                    prop="grade"
                    width="80px"
                ></el-table-column>
                <el-table-column
                    label="座位号"
                    prop="sitNum"
                    width="80px"
                ></el-table-column>
                <!-- <el-table-column
                    label="学校"
                    prop="schoolName"
                    width="220px"
                ></el-table-column> -->
                <el-table-column
                    label="Round1（1分）"
                    prop="round1"
                    width="140px"
                >
                    <template slot-scope="scope">
                        <el-checkbox
                            v-model="scope.row.round1"
                            :disabled="
                                scope.row.score === -1 || scope.row.score === -2
                            "
                            :true-label="1"
                            :false-label="0"
                            :style="{ '--fill-color': '#67C23A' }"
                            @change="onPassClickChange(scope)"
                        >
                            对
                        </el-checkbox>
                        <el-checkbox
                            v-model="scope.row.round1"
                            :disabled="
                                scope.row.score === -1 || scope.row.score === -2
                            "
                            :true-label="0"
                            :false-label="1"
                            @change="onPassClickChange(scope)"
                            :style="{ '--fill-color': '#F56C6C' }"
                        >
                            错
                        </el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Round2（2分）"
                    prop="round2"
                    width="140px"
                >
                    <template slot-scope="scope">
                        <el-checkbox
                            v-model="scope.row.round2"
                            :disabled="
                                scope.row.score === -1 || scope.row.score === -2
                            "
                            :true-label="1"
                            :false-label="0"
                            :style="{ '--fill-color': '#67C23A' }"
                            @change="onPassClickChange(scope)"
                        >
                            对
                        </el-checkbox>
                        <el-checkbox
                            v-model="scope.row.round2"
                            :disabled="
                                scope.row.score === -1 || scope.row.score === -2
                            "
                            :true-label="0"
                            :false-label="1"
                            @change="onPassClickChange(scope)"
                            :style="{ '--fill-color': '#F56C6C' }"
                        >
                            错
                        </el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Round3（3分）"
                    prop="round3"
                    width="140px"
                >
                    <template slot-scope="scope">
                        <el-checkbox
                            v-model="scope.row.round3"
                            :disabled="
                                scope.row.score === -1 || scope.row.score === -2
                            "
                            :true-label="1"
                            :false-label="0"
                            :style="{ '--fill-color': '#67C23A' }"
                            @change="onPassClickChange(scope)"
                        >
                            对
                        </el-checkbox>
                        <el-checkbox
                            v-model="scope.row.round3"
                            :disabled="
                                scope.row.score === -1 || scope.row.score === -2
                            "
                            :true-label="0"
                            :false-label="1"
                            @change="onPassClickChange(scope)"
                            :style="{ '--fill-color': '#F56C6C' }"
                        >
                            错
                        </el-checkbox>
                    </template></el-table-column
                >
                <el-table-column label="总分" prop="score" width="120px">
                    <template scope="scope">
                        <span class="scoreClass">{{ scope.row.score }}</span>
                    </template>
                </el-table-column>
                <!-- 是否晋级 2 未晋级 1 晋级 0 未设置 -->
                <el-table-column label="是否晋级" prop="promotion">
                    <template slot-scope="scope">
                        <el-tag
                            :type="
                                scope.row.promotion === 1
                                    ? 'success'
                                    : scope.row.promotion === 0
                                    ? 'danger'
                                    : 'info'
                            "
                            size="mini"
                        >
                            {{
                                scope.row.promotion === 1
                                    ? "晋级"
                                    : scope.row.promotion === 0
                                    ? "未晋级"
                                    : "未设置"
                            }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            size="small"
                            @click="changeQualificationDig(scope.row)"
                            >晋级修改</el-button
                        >
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            size="small"
                            @click="showDeleteExamUserDialog(scope.row)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <div class="card-bottom">
                <el-button
                    type="primary"
                    style="width: 200px"
                    @click="examInfoSaveClicked"
                    >保存</el-button
                >
            </div>
        </el-card>
        <el-dialog
            title="修改成绩信息"
            :visible.sync="editScoreDialogVisible"
            @close="editScoreDialogClose"
            width="30%"
        >
            <el-form
                :model="editScoreForm"
                label-width="80px"
                ref="editScoreFormRef"
                :rules="editScoreFormRules"
            >
                <el-form-item label="晋级资格" prop="promotion">
                    <el-radio-group v-model="editScoreForm.promotion">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editScoreDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="editScore">修 改</el-button>
            </span>
        </el-dialog>
              <!-- 批量上传成绩dialog -->
      <el-dialog
          title="批量上传成绩"
          :visible.sync="uploadScoreDialogVisible"
          width="30%"
          @close="uploadScoreDialogClose"
      >
          <div style="color: red">1.先导出“成绩信息列表”</div>
          <div style="color: red">
              2.完善信息表中的“是否晋级”列内容
          </div>
          <div style="color: red">3.上传完善好的文件</div>
          <span slot="footer" class="dialog-footer">
              <el-row>
                  <el-col
                      ><el-upload
                          :action="uploadFileRequest.uploadUrl"
                          ref="uploadScoreRef"
                          :headers="uploadFileRequest.headerObj"
                          :on-progress="uploadScoreProgress"
                          :on-success="uploadScoreSuccess"
                          :on-error="uploadScoreError"
                          :on-exceed="uploadScoreFileExceed"
                          :limit="1"
                          :auto-upload="false"
                      >
                          <el-button
                              slot="trigger"
                              size="small"
                              type="primary"
                              >选取文件</el-button
                          >
                          <el-button
                              style="margin-left: 10px"
                              size="small"
                              type="success"
                              @click="submitUpload"
                              >上传成绩</el-button
                          >
                      </el-upload></el-col
                  >
              </el-row>
          </span>
      </el-dialog>
    </div>
</template>
<script>
import { getExamRoomMatchInfo, nationalSaveScores, updateNationalPromotion, removeExaminationRoomUseByPhone } from '@/http/api'
import env from '@/http/env'

export default {
  name: 'groupB',
  props: {
  },
  data () {
    return {
      editScoreDialogVisible: false,
      uploadScoreDialogVisible: false,
      editScoreForm: {
        promotion: null
      },
      editScoreFormRules: {
        promotion: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      examRooms: [], // 考场下拉列表
      examRoomInfo: {}, // 考场信息
      queryForm: {
        pageNum: 1,
        pageSize: 300
      },
      level: '',
      dataList: [],
      total: 0,
      loading: false,
      rankList: [],
      showRank: false,
      setNextNum: '',
      uploadFileRequest: {
        upLoadType: 'file',
        uploadUrl: env.baseIP + 'en/importScore',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      }
    }
  },
  created () {
    this.getExamRoomList()
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      if (row.score === -1) {
        return 'warning-ibc-row'
      } else if (row.score === -2) {
        return 'warning-row'
      } else {
        return ''
      }
    },
    getExamRoomList () {
      this.$http.get('en/queryExaminationListPage', { params: this.queryForm }).then(res => {
        this.examRooms = res.data.list
      })
    },
    // 切换考场
    examRoomChange (e) {
      // 修改考场信息
      console.log('e', e)
      this.examRoomInfo = this.examRooms.find(item => item.id === e)
      // 获取考生列表
      this.get3DataList()
    },
    // 获取考生列表
    getList () {
      this.get3DataList()
    },
    get3DataList () {
      this.loading = true
      getExamRoomMatchInfo({
        id: this.examRoomInfo.id
      }).then(res => {
        this.loading = false
        this.dataList = res.data
      })
    },
    changeQualificationDig (rowData) {
      if (rowData.id) {
        this.editScoreForm.id = rowData.id
        this.editScoreDialogVisible = true
      } else {
        this.$message({
          message: '请先保存选手答题结果后再设置晋级',
          type: 'warning'
        })
      }
    },
    editScore () {
      updateNationalPromotion(this.editScoreForm).then((res) => {
        this.editScoreDialogVisible = false
        this.$message.success('修改成功')
        this.get3DataList()
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    editScoreDialogClose () {
      this.$refs.editScoreFormRef.resetFields()
    },
    // 成绩单选框点击事件(计算成绩)
    onPassClickChange (scope, type) {
      if (scope.row.score === -1) {
        return
      }
      console.log('scope', scope)
      const rowData = scope.row
      this.totalScore = 0
      if (rowData.round1 === 1) {
        this.totalScore += 1
      }
      if (rowData.round2 === 1) {
        this.totalScore += 2
      }
      if (rowData.round3 === 1) {
        this.totalScore += 3
      }
      if (rowData.round1 !== -1 && rowData.round2 !== -1 && rowData.round3 !== -1) {
        rowData.score = this.totalScore
        this.dataList[scope.index] = rowData
      } else {
        rowData.score = this.totalScore
      }
      this.saveExamInfoData('temporary')
    },
    // 考场成绩信息保存点击事件
    examInfoSaveClicked () {
      this.saveExamInfoData('save')
    },
    showDeleteExamUserDialog (rowData) {
      this.$confirm('是否从该考场中删除该学生?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        removeExaminationRoomUseByPhone({ phone: rowData.phone }).then(res => {
          this.resetVisible = false
          this.$message.success('删除成功')
          this.get3DataList()
        })
      }).catch(() => {
      })
    },
    saveExamInfoData (type) {
      if (type === 'save') {
        console.log('this.dataList', this.dataList)
        for (let index = 0; index < this.dataList.length; index++) {
          const element = this.dataList[index]
          var message = ''
          if ((!element.round1 && element.round1 !== 0) || element.round1 === -1) {
            message = '请选择"' + element.userName + '"  round1  答题是否正确'
            return this.$message.error(message)
          }
          if ((!element.round2 && element.round2 !== 0) || element.round2 === -1) {
            message = '请选择"' + element.userName + '"  round2  答题是否正确'
            return this.$message.error(message)
          }
          if ((!element.round3 && element.round3 !== 0) || element.round3 === -1) {
            message = '请选择"' + element.userName + '"  round3  答题是否正确'
            return this.$message.error(message)
          }
        }
      }
      nationalSaveScores(this.dataList).then(res => {
        if (type === 'temporary') { // 暂存，不做提示处理
          this.$forceUpdate()
          return
        } else {
          this.$alert('保存成功', '提示', {
            confirmButtonText: '确定'
          })
        }
        this.getList()
      })
    },
    // 导出所有考场信息
    exportExamData () {
      var downLoadUrl = env.baseIP + 'en/exportScore'
      console.log('downLoadUrl', downLoadUrl)
      this.$downLoadFile.downLoadFileWithUrlNew(this, downLoadUrl, { roomId: this.queryForm.roomId })
    },
    importScoreInfo () {
      this.uploadScoreDialogVisible = true
    },
    uploadScoreDialogClose () {
      this.$refs.uploadScoreRef.clearFiles()// 清除文件
    },
    uploadScoreProgress () {
      // this.$common.openLoading()
    },
    uploadScoreSuccess (res) {
      console.log('uploadScoreSuccess', res)
      if (res.code !== 200) {
        this.$refs.uploadScoreRef.clearFiles()// 清除文件
        return this.$alert('请修改后再上传，失败原因：' + res.msg, '上传失败', {
          confirmButtonText: '确定',
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
      }
      this.$message.success('上传成绩成功')
      if (this.examRoomInfo.id) {
        this.getList()
      }
      this.uploadScoreDialogVisible = false
    },
    uploadScoreError (error) {
      this.$message.error(error)
    },
    uploadScoreFileExceed (files, fileList) {
      this.$set(fileList[0], 'raw', files[0])
      this.$set(fileList[0], 'name', files[0].name)
      this.$refs.uploadScoreRef.clearFiles()// 清除文件
      this.$refs.uploadScoreRef.handleStart(files[0])// 选择文件后的赋值方法
    },
    signInDialogClose () {
      this.$refs.signInFormRef.resetFields()
    },
    submitUpload () {
      if (this.$refs.uploadScoreRef.uploadFiles.length === 0) {
        return this.$message.warning('请选择要上传的文件')
      }
      this.$confirm('请再次确认所选文件是否正确,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$refs.uploadScoreRef.submit()
      }).catch(() => { })
    }
  }
}
</script>
<style lang="less" scoped>
.info {
    font-size: 14px;
    margin-bottom: 24px;
    // border-top: 1px solid #ebebeb;
    // padding-top: 20px;
}
.info-t {
    // width: 120px;
    margin-right: 12px;
    border-bottom: 2px solid #409eff;
    margin-bottom: 12px;
    display: inline-block;
}
.correct /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: #67c23a;
    border-color: #67c23a;
    box-shadow: none;
}
.correct /deep/ .el-radio-button__inner:hover {
    // color: #fff;
}
.wrong /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: #f56c6c;
    border-color: #f56c6c;
    box-shadow: none;
}
.wrong /deep/ .el-radio-button__inner:hover {
    // color: #fff;
}
.score {
    font-size: 18px;
    color: #409eff;
}

.radio-group {
    cursor: pointer;
    width: 110px;
    height: 32px;
    border: 1px solid #dcdfe6;
    color: #606266;
    font-weight: 500;
    display: flex;
    align-items: center;
    line-height: 32px;
    border-radius: 4px;
    .radio-correct {
        width: 55px;
        text-align: center;
        border-right: 1px solid #dcdfe6;
        &.active {
            background-color: #67c23a;
            color: #fff;
            border-radius: 4px 0 0 4px;
        }
    }
    .radio-wrong {
        width: 55px;
        text-align: center;
        &.active {
            background-color: #f56c6c;
            color: #fff;
            border-radius: 0 4px 4px 0;
        }
    }
}
.num {
    font-size: 18px;
    font-weight: bold;
    color: #409eff;
}
.num1 {
    color: #000;
}
.set-info {
    margin-bottom: 24px;
}
.refresh {
    color: #409eff;
    cursor: pointer;
    margin-left: 12px;
}
.card-bottom {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}
</style>
